// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"848034b7","453":"1c2510f2","801":"10366d03"}[chunkId] + ".chunk.js";
};